import request from "../http/index";

// 列表
export async function GetSaleBillRepeatInfoList(data = {}) {
	const res = await request.post("/api/ba/SaleBillRepeatInfo/List", data);
	return res.data;
}

// 详情
export async function GetSaleBillRepeatInfoInfo(data = {}) {
	const res = await request.post("/api/ba/SaleBillRepeatInfo/Info", data);
	return res.data;
}

// 导出
export async function ExportSaleBillRepeatInfo(data = {}) {
	const res = await request.post("/api/ba/SaleBillRepeatInfo/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

// 新增
export async function AddSaleBillRepeatInfo(data = {}) {
	const res = await request.post("/api/ba/SaleBillRepeatInfo/Add", data);
	return res.data;
}

// 修改
export async function EditSaleBillRepeatInfo(data = {}) {
	const res = await request.post("/api/ba/SaleBillRepeatInfo/Edit", data);
	return res.data;
}

// 删除
export async function DeleteSaleBillRepeatInfo(data = {}) {
	const res = await request.post("/api/ba/SaleBillRepeatInfo/Delete", data);
	return res.data;
}

// 获取医院/付款方列表
export async function GetHospitalList(data = {}) {
	const res = await request.post("/api/ba/Hospital/List", data);
	return res.data;
}
